import React from 'react';
import classNames from 'classnames';
import Waypoint from 'react-waypoint';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import BigPicklistControl from 'Components/ComponentLibrary/Components/Inputs/Picklist/BigPicklistControl';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MoreOptionsIndicator
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/QualitativeQuestion/MoreOptionsIndicator';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import styles from './styles';

function QualitativeQuestionLayout({
  classes,
}) {
  const {
    resource,
    handleChange,
    onSubmit: onSubmitMetaForm,
    metaOverrideSet,
  } = useMetaLayoutContext();
  const isScrolled = useScrollTrigger({ disableHysteresis: true });
  const [isFullyScrolled, setIsFullyScrolled] = React.useState(false);

  useScrollTopOnMount();

  const isMultiLineInput = resource?.meta().field('answer').attr('type') === 'string';
  const showPlaceholder = isMultiLineInput && resource.attr('placeholderText');

  const isMultiPicklist = resource?.meta().field('options').attr('type') === 'multipicklist';
  const isPicklist = resource?.meta().field('options').attr('type') === 'picklist';
  const defaultValue = isMultiPicklist ? [] : undefined;

  return (
    <div className={classes.root}>
      <SurveyStepHeader
        className={classes.header}
        title={resource.attr('primaryText')}
        subtitle={resource.attr('secondaryText')}
      />
      <Box className={classes.content}>
        {(isMultiPicklist || isPicklist) && (
          <BigPicklistControl
            className={classes.question}
            selectId={'options'}
            multiple={isMultiPicklist}
            testName={'qualitative-question'}
            value={resource?.attr('options') || defaultValue}
            options={resource
              .meta()
              .field('options')
              .options()
              .list()
              .map(option => ({
                value: option.attr('id'),
                name: option.attr('prompt'),
              }))}
            onChange={(values, value) => {
              const metaField = metaOverrideSet.applyOverrides(resource.meta().field('options'));
              const transformValue = metaField.attr('_transformValue') || null;

              let v = values;
              if (transformValue) {
                v = transformValue(value, values, resource);
              }

              return handleChange('options', v);
            }}
          />
        )}
        {isMultiLineInput && (
          <MetaField
            attr={'answer'}
            InputProps={{
              multiline: true,
              placeholder: showPlaceholder ? resource.attr('placeholderText') : '',
            }}
          />
        )}
        <MoreOptionsIndicator
          className={classNames(classes.moreOptionsIndicator, {
            [classes.moreOptionsIndicatorHidden]: isScrolled || isFullyScrolled,
          })}
        />
        {/* ---------- Footer ---------- */}
        <SurveyStepFooter
          className={classes.footer}
          onSubmit={onSubmitMetaForm}
          nextDisabled={resource?.attr('options')?.length === 0}
        />
      </Box>
      <Waypoint
        onLeave={() => {
          setIsFullyScrolled(false);
        }}
        onEnter={() => {
          setIsFullyScrolled(true);
        }}
      />
    </div>
  );
}

QualitativeQuestionLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

QualitativeQuestionLayout.defaultProps = {
};

export default withStyles(styles)(QualitativeQuestionLayout);
